// Display formatting helpers.

export const EM_DASH = '—';

export function fmtBytes(n: number | null | undefined): string {
  if (n == null || isNaN(n)) return EM_DASH;
  if (n < 1024) return `${n} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let v = n / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v.toFixed(v < 10 ? 1 : 0)} ${units[i]}`;
}

/** Parse an ISO string; null when absent or unparseable. */
export function parseDate(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const d = new Date(iso);
  return isNaN(d.getTime()) ? null : d;
}

export const dateMain = (d: Date): string =>
  d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });

export const dateSub = (d: Date): string =>
  d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

/** "Jul 23, 2026" for a nullable ISO string. */
export function fmtDate(iso: string | null | undefined): string {
  const d = parseDate(iso);
  return d ? dateMain(d) : EM_DASH;
}

export function fmtRate(hz: number | null | undefined): string {
  if (hz == null) return EM_DASH;
  // Rates are whole numbers in practice (52, 104); don't print "104.0 Hz".
  return `${Number.isInteger(hz) ? hz : hz.toFixed(1)} Hz`;
}

export function fmtNumber(n: number | null | undefined): string {
  return n == null ? EM_DASH : n.toLocaleString();
}

/** Percentage of `part` in `total`, rendered for a stat card. */
export function fmtPercent(part: number, total: number): string {
  if (!total) return '0%';
  return `${Math.round((part / total) * 100)}%`;
}

/**
 * The sensor family that recorded a session, as the server labels it.
 *
 * The server keeps two absences apart and so does this: `null` means the row
 * predates the column and nobody asked, `UNKNOWN` means the recording was asked
 * and could not name its own hardware. The first is a dash; the second is a word.
 */
export function fmtVendor(vendor: string | null | undefined): string {
  if (!vendor) return EM_DASH;
  switch (vendor.toUpperCase()) {
    case 'MOVESENSE':
      return 'Movesense';
    case 'SHIMMER':
      return 'Shimmer';
    case 'UNKNOWN':
      return 'Unknown';
    default:
      return vendor;
  }
}
